import Header from '../../../../components/Header'
import { useEffect, useState } from 'react'
import api from '../../../../services/api';
import { toast } from 'react-toastify'
import PastDueBillsList from '../../../../components/PastDueBillsList';
import Footer from '../../../../components/Footer';

export default function Renegotiation() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   
  })

  return (
    <>
        <Header/>        
        <PastDueBillsList/>
        <Footer/>
    </>
  )
}